import axios from "axios";
import React, { useEffect, useState } from "react";
import baseUrl from "../../baseUrl";
import { parseJwt } from "../../utils/parseJwt";
import EmptyData from "../EmptyData/EmptyData";
import FollowerCard from "../FollowerCard/FollowerCard";
import Spinner from "../Spinner/Spinner";

const Followers = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const userId = parseJwt(token).id;
    axios
      .post(
        `${baseUrl}/user/followers`,
        { id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setFollowers(res.data.followers);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);
  return (
    <>
      {loading && <Spinner />}
      <div className="overflow-x-auto">
        <div className="min-w-screen  flex items-center justify-center bg-gray-100 font-sans overflow-hidden">
          <div className="w-full lg:w-5/6">
            <div className="bg-white shadow-md rounded my-1">
              {followers.length <= 0 ? (
                <EmptyData message={"Oopss! You have no followers."} />
              ) : (
                <table className="min-w-max w-full table-auto">
                  <thead>
                    <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                      <th className="py-3 px-6 text-center">Avatar</th>
                      <th className="py-3 px-6 text-left">Name</th>
                      <th className="py-3 px-6 text-left">Email</th>
                      <th className="py-3 px-6 text-center">Type</th>
                      <th className="py-3 px-6 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-600 text-sm font-light">
                    {followers.map((follower) => (
                      <FollowerCard key={follower._id} follower={follower} />
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Followers;
